import * as React from 'react';
import { c } from '../../../utils/tailwind-merge';
import { TextareaProps } from './Textarea.types';

function Textarea({
  className = '',
  dark = false,
  ...props
}: React.ComponentProps<'textarea'> & TextareaProps) {
  const defaultStyles = `caret-blue-hover leading-6 text-base tracking-[-0.096px] h-28 w-56 rounded-lg border px-3 py-2`;

  const lightStyles = `
    border-[#999] text-grey-900 placeholder:text-[#999]
    placeholder:opacity-100
    hover:border-grey-700 hover:bg-grey-100
    read-only:pointer-events-none read-only:border-0 read-only:bg-grey-100 read-only:placeholder:text-grey-900
    focus:border-grey-700 focus:outline-none focus:ring-2 focus:ring-blue-hover focus:ring-offset-2 focus:bg-white
    disabled:border-0 disabled:bg-grey-100 disabled:!text-[#999]`;

  const darkStyles = `
    border-grey-500 text-white bg-grey-900
    hover:border-grey-600 hover:bg-grey-800
    read-only:pointer-events-none read-only:border-0 read-only:bg-grey-800 read-only:placeholder:text-grey-100
    focus:ring-blue-hover focus:ring-offset-grey-800 focus:bg-grey-900 focus:border-grey-700 focus:outline-none focus:ring-2 focus:ring-offset-2
    disabled:border-0 disabled:bg-grey-800 disabled:!text-grey-500`;

  return (
    <textarea
      data-slot="textarea"
      className={c(
        dark
          ? `${defaultStyles} ${darkStyles}`
          : `${defaultStyles} ${lightStyles}`,
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
